import { PayloadAction } from '@reduxjs/toolkit';
//@ts-ignore
import * as api from '@yandex-int/k-common/client/api';
import { call, put, takeEvery } from 'redux-saga/effects';

import { reportMessage } from '../../utils/raven-message';
import { showNetworkError } from '../notification/actions';

import { quizActions } from './slice';
import { GetQuizzesResponse } from './typings';

function* getQuizzesSaga() {
    try {
        const response: GetQuizzesResponse = yield call(api.getQuizzes);

        const quizzesWithQuestions = response.results.filter((quiz) => quiz.questions.length > 0);

        yield put(quizActions.setQuizzes({ ...response, results: quizzesWithQuestions }));
    } catch (error) {
        reportMessage(`Произошла ошибка (${error.status}) при получении викторин`, error.message);

        yield put(showNetworkError());
    }
}

function* deleteQuizSaga(action: PayloadAction<string>) {
    const quizId = action.payload;

    try {
        yield call(api.deleteQuiz, quizId);

        yield put(quizActions.deleteQuizFromQuizzesToDelete(quizId));
    } catch (error) {
        reportMessage(`Произошла ошибка (${error.status}) при удалении викторины`, error.message);

        yield put(quizActions.restoreQuizFromQuizzesToDelete(quizId));

        yield put(showNetworkError());
    }
}

export function* quizWatcher() {
    yield takeEvery(quizActions.getQuizzes.type, getQuizzesSaga);
    yield takeEvery(quizActions.deleteQuiz.type, deleteQuizSaga);
}
